import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductSwitchOffer } from "gql/graphql";

export type ProductSwitchState = {
  currentProductName: string | null;
  offers: ProductSwitchOffer[];
};

const initialState: ProductSwitchState = {
  currentProductName: null,
  offers: [],
};

const productSwitchSlice = createSlice({
  name: "productSwitch",
  initialState,
  reducers: {
    setProductSwitchData(
      state,
      action: PayloadAction<Partial<ProductSwitchState>>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setProductSwitchData } = productSwitchSlice.actions;

export default productSwitchSlice;
